import React from 'react';
import {
  Layout, Table, Button, Modal, message, Popconfirm
} from 'antd';
import axios from 'axios';
import NewsForm from '../NewsForm';
import './index.scss';

const { Content } = Layout;

class NewsManage extends React.Component {
  state = {
    newsList: [],
    modalVisible: false,
    editingNews: null, // null 代表新增，非 null 为编辑模式
  };

  componentDidMount() {
    this.fetchNewsList();
  }

  fetchNewsList = async () => {
    try {
      const res = await axios.get('http://121.43.43.52:8000/applets/news/list');      
      this.setState({ newsList: res.data.page.list || [] });
    } catch (err) {
      message.error('加载新闻列表失败');
    }
  };

  handleEdit = (record) => {
    this.setState({ modalVisible: true, editingNews: record });
  };

  handleDelete = async (record) => {
    try {
      await axios.post(`http://121.43.43.52:8000/applets/news/delete`,[record.id]);
      message.success('删除成功');
      this.fetchNewsList();
    } catch (err) {
      message.error('删除失败');
    }
  };

  handleAdd = () => {
    this.setState({ modalVisible: true, editingNews: null });
  };

  handleModalClose = () => {
    this.setState({ modalVisible: false, editingNews: null });
  };

  handleFormSubmit = async (formData) => {
    const { editingNews } = this.state;
  
    const url = editingNews
      ? 'http://121.43.43.52:8000/applets/news/update'
      : 'http://121.43.43.52:8000/applets/news/save';
  
    // 如果是更新，确保添加 id
    const dataToSend = editingNews
      ? { ...formData, id: editingNews.id }
      : formData;
  
    try {
      await axios.post(url, dataToSend);
      message.success(editingNews ? '修改成功' : '新增成功');
      this.handleModalClose();
      this.fetchNewsList();
    } catch (err) {
      message.error('保存失败');
    }
  };

  render() {
    const { newsList, modalVisible, editingNews } = this.state;
    console.log(editingNews,'editingNews');
    

    const columns = [
      { title: '主标题', dataIndex: 'mainTitle', key: 'mainTitle' },
      { title: '标题简介', dataIndex: 'subTitle', key: 'subTitle' },
      { title: '选择时间', dataIndex: 'publishTime', key: 'publishTime' },
      {
        title: '操作',
        render: (_, record) => (
          <>
            <Button type="link" onClick={() => this.handleEdit(record)}>查看</Button>
            <Popconfirm
              title="确认删除吗？"
              onConfirm={() => this.handleDelete(record)}
              okText="是" cancelText="否"
            >
              <Button type="link" danger>删除</Button>
            </Popconfirm>
          </>
        )
      }
    ];

    return (
      <Layout className="main-container">
        <div className="page-content" >
          <Button color="#1677FF" variant="outlined" onClick={this.handleAdd} style={{ margin: 16}}>新增新闻</Button>
          <Table
            rowKey="id"
            dataSource={newsList}
            columns={columns}
          />
        </div>

        <Modal
          title={editingNews ? '编辑新闻' : '新增新闻'}
          open={modalVisible}
          onCancel={this.handleModalClose}
          footer={null}
          width={800}
          destroyOnClose
        >
          <NewsForm
            initialData={editingNews}
            onSubmit={this.handleFormSubmit}
            onCancel={this.handleModalClose}
          />
        </Modal>
      </Layout>
    );
  }
}

export default NewsManage;